import React, { useState } from 'react';

import { notification } from 'antd';

import styled from 'styled-components';

import { useUserPermission } from '@contexts/UserContext';

import useNwBreakPoints from '@hooks/Layout/UseNwBreakPoints';

import BillingInfoDrawer from '@components/BillingInfos/BillingInfoDrawer';
import NwIcon from '@components/Gui/NwIcon';
import PermissionBlock from '@components/PermissionBlock/PermissionBlock';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const ContactBillingInfoContainer = styled.p`
    text-transform: uppercase;
    margin-bottom: 0;
`;

const ContactHeaderBillingInfos = ({ currentContact, readOnly, mobileFullRow }) => {
    const [drawer, setDrawer] = useState(false);
    const breakpoints = useNwBreakPoints();

    const canViewBillingInfos = useUserPermission('ViewBillingInfos');

    const openBillingInfosDrawer = () => {
        if (canViewBillingInfos) {
            setDrawer(true);
        } else {
            notification.error({
                message: 'You are not allowed to view billing infos',
                //description: 'Please contact your administrator to view billing infos',
                duration: 5,
            });
        }
    };

    const renderContactBillingInfosContainer = () => {
        return currentContact.BillingInfosCount ? (
            <ContactBillingInfoContainer onClick={mobileFullRow ? undefined : openBillingInfosDrawer}>
                {breakpoints !== 1 && (
                    <>
                        <NwIcon icon={byPrefixAndName.fasl['file-invoice-dollar']} />
                        &nbsp;&nbsp;
                    </>
                )}
                {currentContact.BillingInfosCount}{' '}
                {currentContact.BillingInfosCount > 1 ? 'billing profiles' : 'billing profile'}
            </ContactBillingInfoContainer>
        ) : (
            <ContactBillingInfoContainer onClick={mobileFullRow ? undefined : openBillingInfosDrawer}>
                <NwIcon icon={byPrefixAndName.fasl['file-invoice-dollar']} danger />
                &nbsp;&nbsp;no billing profiles
            </ContactBillingInfoContainer>
        );
    };

    return (
        <>
            {currentContact && (
                <div
                    className={`header-body-boxes header-body-boxes-hoverable${mobileFullRow ? ' mobile-full-row-trigger' : ''}`}
                    onClick={mobileFullRow ? openBillingInfosDrawer : undefined}
                >
                    <PermissionBlock permission={canViewBillingInfos} content={renderContactBillingInfosContainer()} />
                </div>
            )}
            {drawer && (
                <BillingInfoDrawer
                    type={currentContact.ContactType}
                    subtype={currentContact.SubType}
                    contactId={currentContact.ID}
                    readOnly={readOnly}
                    onClose={() => setDrawer(false)}
                />
            )}
        </>
    );
};

export default ContactHeaderBillingInfos;
